export default __webpack_public_path__ + "static/media/SndLowerPSwimUpOver.5fbe45c2.mp3";